{
	"viewAllUsers": {
		"object": { "resource_type": "user" },
		"action": "read"
	},
	"updateUsers": {
		"object": { "resource_type": "user" },
		"action": "update"
	},
	"createUser": {
		"object": { "resource_type": "user" },
		"action": "create"
	},
	"createTemplates": {
		"object": { "resource_type": "template", "any_org": true },
		"action": "create"
	},
	"createWorkspace": {
		"object": {
			"resource_type": "workspace",
			"any_org": true,
			"owner_id": "me"
		},
		"action": "create"
	},
	"updateTemplates": {
		"object": { "resource_type": "template" },
		"action": "update"
	},
	"updateAnyTemplate": {
		"object": { "resource_type": "template", "any_org": true },
		"action": "update"
	},
	"deleteTemplates": {
		"object": { "resource_type": "template" },
		"action": "delete"
	},
	"viewDeploymentConfig": {
		"object": { "resource_type": "deployment_config" },
		"action": "read"
	},
	"editDeploymentConfig": {
		"object": { "resource_type": "deployment_config" },
		"action": "update"
	},
	"viewDeploymentStats": {
		"object": { "resource_type": "deployment_stats" },
		"action": "read"
	},
	"readWorkspaceProxies": {
		"object": { "resource_type": "workspace_proxy" },
		"action": "read"
	},
	"editWorkspaceProxies": {
		"object": { "resource_type": "workspace_proxy" },
		"action": "create"
	},
	"createOrganization": {
		"object": { "resource_type": "organization" },
		"action": "create"
	},
	"viewAnyGroup": {
		"object": { "resource_type": "group" },
		"action": "read"
	},
	"createGroup": {
		"object": { "resource_type": "group" },
		"action": "create"
	},
	"viewAllLicenses": {
		"object": { "resource_type": "license" },
		"action": "read"
	},
	"viewNotificationTemplate": {
		"object": { "resource_type": "notification_template" },
		"action": "read"
	},
	"viewOrganizationIDPSyncSettings": {
		"object": { "resource_type": "idpsync_settings" },
		"action": "read"
	},
	"viewAnyMembers": {
		"object": { "resource_type": "organization_member", "any_org": true },
		"action": "read"
	},
	"editAnyGroups": {
		"object": { "resource_type": "group", "any_org": true },
		"action": "update"
	},
	"assignAnyRoles": {
		"object": { "resource_type": "assign_org_role", "any_org": true },
		"action": "assign"
	},
	"viewAnyIdpSyncSettings": {
		"object": { "resource_type": "idpsync_settings", "any_org": true },
		"action": "read"
	},
	"viewAnyMCPServerConfigs": {
		"object": { "resource_type": "mcp_server_config", "any_org": true },
		"action": "read"
	},
	"createAnyMCPServerConfig": {
		"object": { "resource_type": "mcp_server_config", "any_org": true },
		"action": "create"
	},
	"updateAnyMCPServerConfig": {
		"object": { "resource_type": "mcp_server_config", "any_org": true },
		"action": "update"
	},
	"deleteAnyMCPServerConfig": {
		"object": { "resource_type": "mcp_server_config", "any_org": true },
		"action": "delete"
	},
	"editAnySettings": {
		"object": { "resource_type": "organization", "any_org": true },
		"action": "update"
	},
	"viewAnyAuditLog": {
		"object": { "resource_type": "audit_log", "any_org": true },
		"action": "read"
	},
	"viewAnyConnectionLog": {
		"object": { "resource_type": "connection_log", "any_org": true },
		"action": "read"
	},
	"viewDebugInfo": {
		"object": { "resource_type": "debug_info" },
		"action": "read"
	},
	"viewAnyAIBridgeInterception": {
		"object": { "resource_type": "aibridge_interception", "any_org": true },
		"action": "read"
	},
	"viewAnyAIProvider": {
		"object": { "resource_type": "ai_provider" },
		"action": "read"
	},
	"viewAIGatewayKeys": {
		"object": { "resource_type": "ai_gateway_key" },
		"action": "read"
	},
	"createOAuth2App": {
		"object": { "resource_type": "oauth2_app" },
		"action": "create"
	},
	"editOAuth2App": {
		"object": { "resource_type": "oauth2_app" },
		"action": "update"
	},
	"deleteOAuth2App": {
		"object": { "resource_type": "oauth2_app" },
		"action": "delete"
	},
	"viewOAuth2AppSecrets": {
		"object": { "resource_type": "oauth2_app_secret" },
		"action": "read"
	},
	"createChat": {
		"object": { "resource_type": "chat", "any_org": true, "owner_id": "me" },
		"action": "create"
	},
	"viewAnyChatModelConfig": {
		"object": { "resource_type": "chat_model_config", "any_org": true },
		"action": "read"
	},
	"createAnyChatModelConfig": {
		"object": { "resource_type": "chat_model_config", "any_org": true },
		"action": "create"
	},
	"editAnyChatModelConfig": {
		"object": { "resource_type": "chat_model_config", "any_org": true },
		"action": "update"
	},
	"deleteAnyChatModelConfig": {
		"object": { "resource_type": "chat_model_config", "any_org": true },
		"action": "delete"
	},
	"shareAnyChatModelConfig": {
		"object": { "resource_type": "chat_model_config", "any_org": true },
		"action": "share"
	}
}
